import { FC, SVGProps } from 'react';
import logoBancoGeneral from '../../assets/images/bancogeneral/logo_bancogeneral.png';
import logoWhiteBancoGeneral from '../../assets/images/logo.png';
import logoSwiftmart from '../../assets/images/swiftmart/logo_swiftmart.png';
import { ReactComponent as LogoBanistmo } from '../../assets/images/banistmo/logo_banistmo.svg';
import logoWhiteBanistmoUrl, { ReactComponent as LogoWhiteBanistmo } from '../../assets/images/banistmo/logo_banistmo_white.svg';
import logoKinpos from '../../assets/images/kinpos/logo_kinpos.png';
import logoWhiteKinpos from '../../assets/images/kinpos/logo_kinpos_white.png';
import { BRAND_NAME, INSTANCE } from '../../utils/appConfig';

// Logos por instancia: a color (login, registro, cambio de clave) y blanco para el menú lateral (fondo --primary-color).
// Los SVG se insertan en línea y no como <img>: algunos navegadores (Safari) rasterizan el <img> SVG y lo agrandan pixelado.
// Tinted: logo blanco usado como máscara y pintado con el color de la marca (instancias sin versión a color del logo).
type Tinted = { mask: string; ratio: number; color: string };
type Logo = string | Tinted | FC<SVGProps<SVGSVGElement>>;
type InstanceLogos = { color: Logo; white: Logo };

const DEFAULT_LOGOS: InstanceLogos = { color: { mask: logoSwiftmart, ratio: 616 / 200, color: '#0085cb' }, white: logoSwiftmart };

const LOGOS: Record<string, InstanceLogos> = {
    swiftmart: DEFAULT_LOGOS,
    bancogeneral: { color: logoBancoGeneral, white: logoWhiteBancoGeneral },
    banistmo: { color: LogoBanistmo, white: LogoWhiteBanistmo },
    kinpos: { color: logoKinpos, white: logoWhiteKinpos },
};

// URL del logo blanco de la instancia, para las pantallas públicas (menú QR, términos, voucher…) con cabecera --primary-color
const WHITE_LOGO_URLS: Record<string, string> = {
    swiftmart: logoSwiftmart,
    bancogeneral: logoWhiteBancoGeneral,
    banistmo: logoWhiteBanistmoUrl,
    kinpos: logoWhiteKinpos,
};
export const INSTANCE_WHITE_LOGO_URL = WHITE_LOGO_URLS[INSTANCE] ?? logoSwiftmart;

type Props = { white?: boolean; className?: string };

export const InstanceLogo = ({ white = false, className }: Props) => {
    const logos = LOGOS[INSTANCE] ?? DEFAULT_LOGOS;
    const Logo = white ? logos.white : logos.color;

    if (typeof Logo === 'string') return <img src={Logo} alt={BRAND_NAME} className={className} />;
    if ('mask' in Logo) {
        const mask = `url(${Logo.mask}) center / contain no-repeat`;
        return <span role="img" aria-label={BRAND_NAME} className={className}
            style={{ aspectRatio: Logo.ratio, background: Logo.color, mask, WebkitMask: mask }} />;
    }
    // Alineado a la izquierda como el object-position del menú; centrado en las pantallas de acceso
    return <Logo role="img" aria-label={BRAND_NAME} className={className}
        preserveAspectRatio={white ? 'xMinYMid meet' : 'xMidYMid meet'} />;
};
